import React from 'react';
import UploadFileSmall from '../../uploadfile/UploadFileSmall';
import { UploadFile } from '../../components/forms/UploadFile';
import { isJpgMediaExtension } from '../../api/media';
import { MediaCarousel } from '../form/PublicationForm';

type Props = {
    media: string;
    extension: string;
    handleMediaChange: (
        e: React.ChangeEvent<HTMLInputElement>,
        networkKey?: string,
        index?: number,
    ) => void;
    resetMedia: (networkKey?: string) => void;
    resetMediaSmall: (networkKey?: string, index?: number) => void;
    mediaUrl: string;
    medias: MediaCarousel[];
    link: string;
    isViewOnly: boolean;
    isGlobal: boolean;
};

export function MediaPublicationInput({
    media,
    extension,
    handleMediaChange,
    resetMedia,
    resetMediaSmall,
    mediaUrl,
    medias,
    link,
    isViewOnly,
    isGlobal,
}: Props) {
    return (
        <div className="w-[300px] flex-1">
            <label htmlFor="media">Ajouter un média</label>
            <UploadFile
                media={media}
                extension={extension}
                handleMediaChange={handleMediaChange}
                resetMedia={resetMedia}
                disabled={!!link || isViewOnly}
                isGlobal={isGlobal}
                isViewMode={isViewOnly}
            />
            <div className="flex justify-around flex-wrap gap-2">
                {mediaUrl &&
                    isJpgMediaExtension(extension) &&
                    medias.map((mediaItem, index) => {
                        const itemKey = mediaItem.id ?? `carousel-slot-${index}`;

                        return (
                            <div key={itemKey} className="flex flex-col">
                                <label
                                    htmlFor={`mediaCarousel-${itemKey}`}
                                    className={'text-[12px] font-light mx-auto'}
                                >
                                    Image {index + 2}
                                </label>
                                <UploadFileSmall
                                    media={mediaItem.url || ''}
                                    index={index}
                                    handleMediaChange={handleMediaChange}
                                    resetMedia={() => resetMediaSmall(undefined, index)}
                                    disabled={!mediaUrl || medias.length > 9 || isViewOnly}
                                    isViewMode={isViewOnly}
                                />
                            </div>
                        );
                    })}
            </div>
        </div>
    );
}
